import { render, staticRenderFns } from "./LotteryStatistic.vue?vue&type=template&id=03f59fd2&"
import script from "./LotteryStatistic.vue?vue&type=script&lang=js&"
export * from "./LotteryStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports